import { render, staticRenderFns } from "./BooleanColumn.vue?vue&type=template&id=6f0c316c&"
import script from "./BooleanColumn.vue?vue&type=script&lang=js&"
export * from "./BooleanColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports